 <template>
  <li>
    <span class="word">
      {{ keyword }}
    </span>
    <button class="rm" @click="$emit('removeKeyword', keyword)">
      &times;
    </button>
  </li>
</template>

<script>
export default {
  name: 'KeywordItem',
  props: {
    keyword: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped>
li {
  background: #98a0ad;
  border-radius: 7px;
  display: inline-flex;
  justify-content: space-between;
  padding: 6px 5px;
  margin: 1px 2px;
  cursor: default;
}
.word {
  color: #ffffff;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 464px;
  font-size: 12px;
}
.rm {
  outline: none;
  color: #000000;
  display: block;
  background: #98a0ad00;
  border: none;
  margin-top: -12px;
  margin-left: 10px;
  cursor: pointer;
}
</style>
